import React from 'react';
import { connect } from 'react-redux';
import { cartStatsSelector } from '../../../modules/selectors/standort/session/cartStats';
import { fetchCartStatsIfNeeded } from '../../../modules/actions/standort/session/cartStats';
import { frontloadConnect } from 'react-frontload';
import StandortLink from '../VHost/StandortLink';

const CartLink = ({ cartStats }) => {
    const numOfProducts = cartStats.numOfPos || 0;
    const ariaLabel =
      numOfProducts === 0
        ? 'Warenkorb'
        : numOfProducts === 1
          ? 'Warenkorb, 1 Produkt'
          : `Warenkorb, ${numOfProducts} Produkte`;
          
    return (
        <StandortLink to="/warenkorb" ariaLabel={ariaLabel} className="focus">
            <div className="uk-position-relative">
                <span className="uk-margin-small-right" data-uk-icon="icon: cart; ratio: 1.5" aria-hidden="true"/>
                <div className="uk-badge uk-position-absolute" style={{ height: 20, minWidth: 20, top: -8, right: 0 }} aria-hidden="true">
                    {numOfProducts}
                </div>
            </div>
        </StandortLink>
    );
};

const frontload = async props => {
    await Promise.all([props.fetchCartStatsIfNeeded()]);
};

const mapStateToProps = state => {
    return {
        cartStats: cartStatsSelector(state),
    };
};

const mapDispatchToProps = { fetchCartStatsIfNeeded };

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(frontloadConnect(frontload, { onUpdate: true, noServerRender: true })(CartLink));
